import { useState, useEffect } from 'react';
import '../../../../css/custom-scrollbar.css';
import { useMyContext } from '../../../../context/MyContext';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PaginationItem from '@mui/material/PaginationItem';
import { MdDashboard } from 'react-icons/md';
import { ndrList, Base_Url, ndr, pendingApi, ndrStatusList, ndrAction } from '../../../../config/config';
import { toast } from 'react-toastify';
import { CgSearch } from "react-icons/cg";
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';
import Ndrmodel from '../../../../component/b2c/models/ndrModel';
import axios from 'axios';


export default function NDRDashboard() {
  const [activeTab, setActiveTab] = useState('Action Pending');
   const [isPageLoading, setIsPageLoading] = useState(false)
  const { setorderId } = useMyContext()
  const [limit, setLimit] = useState(10);
  const [ndrListData, setNdrListData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [originalData, setOriginalData] = useState([]);
  // Add new state to track API total separately
  const [apiTotalItems, setApiTotalItems] = useState(0);
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [ndrdata, setNdrData] = useState([]);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [pagination, setPagination] = useState({
    'Action Pending': 1,
    'Action Taken': 1,
    'RTO Delivered': 1,
    'All Details': 1,
  });

  const navigateForTrack = useNavigate();
  const tabs = ['Action Pending', 'Action Taken', 'RTO Delivered', 'All Details'];
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');

  // const handleViewClick = (ndr) => {
  //   setNdrData(ndr);
  //   setIsPopupOpen(true)
  // }

  // handleViewClick function
  const handleViewClick = (ndr) => {
    if (ndr.order_partner?.toLowerCase() === "ekart") {
      // open modal only for ekart
      setNdrData(ndr);
      setIsPopupOpen(true);
    } else {
      // directly call API for others
      handleRemmitance(ndr);
    }
  };

  // onSubmit function
  const handleRemmitance = async (data) => {
    setIsPageLoading(true);
    const editNdrEndpoint = Base_Url + ndrAction;

    const payload = {
      order_id: data.order_id,
      // address: data.order_drop_address,
      // phone: data.order_phone,
      action: "Re-attempt",
    };

    try {
      const response = await axios.post(editNdrEndpoint, payload, {
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });

      if (response.data.status === "SUCCESS") {
        fetchNdrListByCurrentTab();
        toast.success(response.data.message || "NDR data updated successfully");
        setIsPageLoading(false);
      } else {
        toast.error(response.data.message || "Failed to update NDR data");
         setIsPageLoading(false);
      }
    } catch (error) {
      const errorData = error.response?.data;
      if (errorData?.messages && typeof errorData.messages === "object") {
        const detailedErrors = Object.values(errorData.messages).join(", ");
        toast.error(detailedErrors || "Validation error occurred");
         setIsPageLoading(false);
      } else {
        toast.error(errorData?.message || "An error occurred while updating NDR data");
         setIsPageLoading(false);
      }
    } finally {
      setIsPageLoading(false);
    }
  };


  const handleClose = () => {
    setIsPopupOpen(false);
    setNdrData(ndr);
  };

  useEffect(() => {
    fetchNdrListByCurrentTab();
  }, [activeTab, pagination[activeTab], limit]);

  // Fixed search functionality
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setNdrListData(originalData);
      // When search is cleared, show filtered count for display but keep API total for pagination
      setTotalOrders(apiTotalItems);
    } else {
      const filtered = originalData.filter(item =>
        item.waybill?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setNdrListData(filtered);
      // When searching, show filtered count
      setTotalOrders(filtered.length);
    }
  }, [searchQuery, originalData, apiTotalItems]);

  const renderTableHeaders = () => {
    const commonHeaders = ['Order ID', 'AWB No.', 'NDR Count', 'Reason', 'Last Updated'];

    if (activeTab === 'Action Pending' || activeTab === 'All Details' || activeTab === 'Action Taken') {
      return [...commonHeaders, 'Action'];
    }
    return commonHeaders;
  };

  const fetchNdrListByCurrentTab = async () => {
    const pageNumber = pagination[activeTab];
    const limitNumber = Number(limit) || 10;
    setIsPageLoading(true);
    try {
      let url = '';
      if (activeTab === 'Action Pending') {
        url = `${Base_Url}${ndrList}/Pending?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'Action Taken') {
        url = `${Base_Url}${ndrStatusList}?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'RTO Delivered') {
        url = `${Base_Url}${ndrList}/RTO?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'All Details') {
        url = `${Base_Url}${ndrList}?page=${pageNumber}&limit=${limitNumber}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid || '',
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (result.status === "SUCCESS") {
        // const data = result.data;
        const data = Array.isArray(result.data) ? result.data : []; 
        const totalItems = result.pagination?.totalItems || 0;
 
        setOriginalData(data);
        setNdrListData(data);
        // setPartner(data.data[0].order_partner)
        setApiTotalItems(totalItems);
        setTotalOrders(totalItems);
        setIsPageLoading(false);

      } else {
        toast.error(result.message || "Failed to fetch data");
        setNdrListData([]);
        setTotalOrders(0);
        setOriginalData([]);
        setApiTotalItems(0);
        setIsPageLoading(false);
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error("An error occurred while fetching data");
      setNdrListData([]);
      setTotalOrders(0);
      setOriginalData([]);
      setApiTotalItems(0);
       setIsPageLoading(false);
    }
  };

  const handlePaginationChange = (event, value) => {
    setPagination(prev => ({
      ...prev,
      [activeTab]: value,
    }));
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPagination(prev => ({
      ...prev,
      [activeTab]: 1,
    }));
  };

  const handleReturn = async (order_id, action) => {
    try {
      const urlPost = Base_Url + ndrAction;
      setIsPageLoading(true);
      const response = await fetch(urlPost, {
        method: 'POST',
        headers: {
          token: token,
          cus_id: cusid || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: order_id,
          action: action
        }),
      });

      const result = await response.json();

      if (result.status === "SUCCESS") {
        fetchNdrListByCurrentTab();
        toast.success(result.message);
        setIsPageLoading(false);
      } else {
        toast.error(result.message || "Action failed");
        setIsPageLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred while processing your request");
      console.error('API error:', error.message);
      setIsPageLoading(false);
    }
  };


  const handleClick = (orderID) => {
    setorderId(orderID);
    navigateForTrack("/shipments/tracking ");
  }

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  const renderTableRow = (item, index) => {
    // const customerName = item.order_first_name && item.order_last_name
    //   ? `${item.order_first_name} ${item.order_last_name}`
    //   : (item.order_first_name || "N/A");


    const commonCells = [
      <td
        key="orderId"
        onClick={() => handleClick(item.order_id)}
        className="relative group p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
      >
        {item.order_id || "N/A"}

        {/* Tooltip */}
        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
          📦 Track your shipment status here!
          <div className="absolute -top-1 left-3 w-2 h-2 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
        </div>
      </td>,

      <td key="awbNo" className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">
        {item.waybill || "N/A"}
      </td>,

      // <td key="customerInfo" className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">
      //   {customerName}
      // </td>,

      <td key="count" className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">
        {item.count || "N/A"}
      </td>,

      <td key="reason" className="p-2">
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200">
          {item.reason || "N/A"}
        </span>
      </td>,

      <td key="lastUpdated" className="p-2 text-xs text-gray-600 dark:text-gray-400 font-mono">
        {item.updated_at || "N/A"}
      </td>,
    ];


    if (activeTab === 'Action Pending') {
      commonCells.push(
        <td key="action" className="p-2">
          <div className="flex items-center gap-1">
            <Button
              variant="contained"
              size="small"
              onClick={() => handleViewClick(item)}
              color="primary"
              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
              style={{
                backgroundColor: '#3b82f6',
                '&:hover': { backgroundColor: '#2563eb' },
                textTransform: 'capitalize',
                fontSize: '10px',
                padding: '4px 8px',
                minHeight: '24px'
              }}
            >
              Reattempt
            </Button>
            <Button
              variant="contained"
              size="small"
              color="warning"
              onClick={() => handleReturn(item.order_id, 'Return')}
              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
              style={{
                backgroundColor: '#f59e0b',
                '&:hover': { backgroundColor: '#d97706' },
                textTransform: 'capitalize',
                fontSize: '10px',
                padding: '4px 8px',
                minHeight: '24px'
              }}
            >
              Return
            </Button>
          </div>
        </td>
      );
    } else if (activeTab === 'All Details' || activeTab === 'Action Taken') {
      commonCells.push(
        <td key="action" className="p-2">
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
            {item.action || "N/A"}
          </span>
        </td>
      );
    }

    return (
      <tr
        key={index}
        className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
          ? 'bg-white dark:bg-darkmodeColor'
          : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
          }`}
      >
        {commonCells}
      </tr>
    );
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setPagination(prev => ({
      ...prev,
      [tab]: 1,
    }));
    setSearchQuery('');
  };

  const NoDataMessage = () => (
    <tr>
      <td colSpan={renderTableHeaders().length} className="p-4 text-center">
        No data available
      </td>
    </tr>
  );

  // Calculate pagination count based on whether search is active
  const getPaginationCount = () => {
    if (searchQuery.trim() !== '') {
      // When searching, disable pagination (show all results on one page)
      return 1;
    }
    // When not searching, use API total for pagination
    return Math.ceil(apiTotalItems / limit) || 1;
  };
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}


        <FullPageLoader
        isLoading={isPageLoading}
        message="Processing your request..."
      />

        <div className="w-full mt-4 mb-4 mr-4 ml-4 overflow-x-hidden bg-white overflow-y-auto dark:bg-darkmodeColor custom-scrollbar dark:shadow-custom-dark shadow-custom-light rounded-custom">
          <div className="container mx-auto p-6">
            {/* Header Section */}
            <div className="mb-8">
              <div className="bg-customPurple text-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02]">
                <button className="w-full px-6 py-4 flex items-center justify-center gap-3 font-sans font-semibold text-lg sm:text-xl">
                  <MdDashboard className="text-2xl" />
                  <span>NDR Dashboard</span>
                </button>
              </div>
            </div>

            {/* Search Section */}
            <div className="mb-8">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative flex items-center bg-white dark:bg-[rgba(1,14,78,0.8)] border-2 border-gray-200 dark:border-gray-600 rounded-xl shadow-sm hover:shadow-md focus-within:shadow-lg focus-within:border-blue-500 dark:focus-within:border-blue-400 transition-all duration-300">
                  <div className="pl-4 pr-3">
                    <CgSearch className="text-gray-400 dark:text-gray-300 transition-colors duration-200 group-focus-within:text-blue-500" size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search by AWB Number..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="flex-1 p-4 bg-transparent outline-none dark:text-white text-gray-700 placeholder-gray-400 dark:placeholder-gray-300 text-sm font-medium"
                  />
                  {searchQuery && (
                    <button
                      onClick={clearSearch}
                      className="mr-4 p-1 text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-red-50 dark:hover:bg-red-900/20"
                    >
                      <span className="sr-only">Clear search</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Tabs Section */}
            <div className="mb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {tabs.map((tab, index) => (
                  <button
                    key={tab}
                    className={`group relative px-6 py-4 font-sans font-medium text-sm rounded-xl transition-all duration-300 transform hover:scale-[1.02] ${activeTab === tab
                      ? 'bg-customPurple text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                      : 'bg-white dark:bg-[rgba(1,14,78,0.8)] text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:border-blue-300 dark:hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-[rgba(1,14,78,0.9)] shadow-sm hover:shadow-md'
                      }`}
                    onClick={() => handleTabClick(tab)}
                  >
                    <div className="flex items-center justify-center gap-2">
                      {tab === 'Action Pending' && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      {tab === 'All Details' && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      )}
                      {tab === 'Action Taken' && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      <span>{tab}</span>
                    </div>

                    {activeTab === tab && (
                      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-white rounded-full"></div>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* <div className="rounded-custom dark:shadow-none p-4"> */}
            <div className="overflow-x-auto rounded-xl">
              <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                <thead className="bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
                  <tr>
                    {renderTableHeaders().map((header, index) => (
                      <th key={index} className="p-2 text-left font-medium">
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                  {ndrListData.length > 0 ? (
                    ndrListData.map((item, index) => renderTableRow(item, index))
                  ) : (
                    <NoDataMessage /> 
                  )}
                </tbody>
              </table>
              {/* </div> */}

              <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                <span className="text-sm text-gray-700 font-bold dark:text-gray-300">
                  {searchQuery ? `Filtered: ${totalOrders} / Total: ${apiTotalItems}` : `Total Orders: ${totalOrders}`}
                </span>
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className="border rounded p-1 text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
                  disabled={searchQuery.trim() !== ''} // Disable limit change when searching
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={totalOrders}>All</option>
                </select>
                <Pagination
                  count={getPaginationCount()}
                  page={searchQuery.trim() !== '' ? 1 : pagination[activeTab]} // Always show page 1 when searching
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  className="pagination sm:mr-4"
                  size="small"
                  disabled={searchQuery.trim() !== ''} // Disable pagination when searching
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className={`mx-1 dark:bg-darkmodeColor dark:text-white rounded-lg dark:shadow-custom-dark ${item.selected ? 'bg-customPurple text-white' : 'text-gray-800'
                        }`}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Ndrmodel isopen={isPopupOpen} onClose={handleClose} ndrdata={ndrdata} />
    </div>
  );
}